import type { BusbarSelectionDataSet } from "../services/busbarSelection";
import type { CalculationRunSummary } from "../services/cable";
import { RunTraceabilityPanel } from "./RunTraceabilityPanel";

type BusbarSelectionTraceabilityProps = {
  run: CalculationRunSummary;
  dataSet: BusbarSelectionDataSet;
  onExport?: () => void;
};

// How many characters of the basis document's SHA-256 the screen shows; the whole value is the
// tooltip.
const SHORT_HASH_LENGTH = 12;

// Traceability record of a persisted run (Master Prompt v2.1 section 19): the run as the server
// stored it, and the controlled data set it was calculated with - the pin the run took when it
// was calculated, which a later change of the basis document never rewrites.
export function BusbarSelectionTraceability({
  run,
  dataSet,
  onExport,
}: BusbarSelectionTraceabilityProps) {
  return (
    <>
      <RunTraceabilityPanel run={run} onExport={onExport} />
      <section aria-label="Controlled data set" data-data-set={dataSet.name}>
        <h3>Controlled data set</h3>
        <dl>
          <dt>Data set</dt>
          <dd data-field="data-set-name">{dataSet.name}</dd>
          <dt>Source document</dt>
          <dd data-field="data-set-document">{dataSet.source_document}</dd>
          <dt>Revision</dt>
          <dd data-field="data-set-revision">{dataSet.revision}</dd>
          <dt>Approval status</dt>
          <dd data-field="data-set-approval">{dataSet.approval_status}</dd>
          <dt>Approved on</dt>
          <dd data-field="data-set-approved-on">{dataSet.approved_on}</dd>
          <dt>Basis file</dt>
          <dd data-field="data-set-basis-file">{dataSet.basis_file}</dd>
          <dt>Basis SHA-256</dt>
          <dd data-field="data-set-sha256" title={dataSet.basis_sha256}>
            {dataSet.basis_sha256.slice(0, SHORT_HASH_LENGTH)}…
          </dd>
        </dl>
      </section>
    </>
  );
}

export default BusbarSelectionTraceability;
